module.exports = __webpack_public_path__ + "img/np1-icon.79372ed8.svg";